import { Component, Input, OnInit } from '@angular/core';
import * as sortBy from 'lodash/sortBy';

import { FlightComm } from '../models/flight-comm.model';
import { EditToggleService } from '../../shared/services/edit-toggle.service';
import { MatDialog, MatDialogConfig, MatSnackBar } from '@angular/material';
import { EditCommunicationComponent } from '../edit-communication/edit-communication.component';
import { DeleteCommunicationComponent } from '../delete-communication/delete-communication.component';

@Component({
  selector: 'app-communication-card',
  templateUrl: './communication-card.component.html',
  styleUrls: ['./communication-card.component.scss']
})
export class CommunicationCardComponent implements OnInit {
  @Input() identifier: string;
  @Input() flightComms: Array<FlightComm>;
  @Input() isIslandSource: boolean;
  editModeSet: boolean;

  constructor( private _toggleService: EditToggleService,
               public _snackBar: MatSnackBar,
               private _editCommDialog: MatDialog,
               private _deleteCommDialog: MatDialog
  ) {}

  ngOnInit() {
    this._toggleService.toggleEmitter.subscribe(isOn => {
      this.editModeSet = isOn;
    });
  }

  get sortedFlightComms(): Array<FlightComm> {
    return this.flightComms.sort((obj1: FlightComm, obj2: FlightComm) => {
      if (obj1.service.toUpperCase() < obj2.service.toUpperCase()) {
        return -1;
      }
      if (obj1.service.toUpperCase() > obj2.service.toUpperCase()) {
        return 1;
      }
      if (obj1.sector === null && obj2.sector !== null) {
        return -1;
      }
      if (obj1.sector !== null && obj2.sector === null) {
        return 1;
      }
      if (obj1.sector < obj2.sector) {
        return -1;
      }
      if (obj1.sector > obj2.sector) {
        return 1;
      }
      if (obj1.frequency < obj2.frequency) {
        return -1;
      }
      if (obj1.frequency > obj2.frequency) {
        return 1;
      }
      return 0;
    });
  }

  openEditCommDialog(comm: FlightComm) {
    let ERROR_MSG = 'An error has occurred, please try back later, or call 1-800-USA-AOPA if the error persists.';
    const dialogRef = this._editCommDialog.open(EditCommunicationComponent, {
      disableClose: false,
      autoFocus: true,
      data: {
        isNew: false,
        comm: comm
      }
    });
    dialogRef.afterClosed().subscribe(isUpdated => {
      if (!isUpdated) { return; }
      if (isUpdated.cancelBtnClicked) {
        return;
      }
      if (isUpdated.success) {
        this._snackBar.open('Communication', 'Updated', {
          duration: 2000
        });
        if (isUpdated.newComm != null) {
          this._snackBar.open('New Frequency', 'Added', {
            duration: 2000
          });
          this.flightComms.push(isUpdated.newComm);
        }
      } else {
        if (isUpdated.error != null) {
          ERROR_MSG = isUpdated.error.message;
        }
        this._snackBar.open(ERROR_MSG, 'Error', {
          duration: 6000
        });
      }
    });
  }

  removeDeletedComm(commId) {
    const index = this.flightComms.findIndex(c => c.flightCommId === commId);
    if (index > -1) {
      this.flightComms.splice(index, 1);
    }
  }

  deleteComm(comm: FlightComm) {
    const dialogConfig = new MatDialogConfig();
    let ERROR_MSG = 'An error has occurred, please try back later, or call 1-800-USA-AOPA if the error persists.';
    dialogConfig.disableClose = true;
    dialogConfig.autoFocus = true;
    dialogConfig.data = {
      commId: comm.flightCommId,
      airportId: comm.airportId,
      frequencyId: comm.frequencyId
    };
    const dialogRef = this._deleteCommDialog.open(DeleteCommunicationComponent, dialogConfig);
    dialogRef.afterClosed().subscribe((isUpdated) => {
      if (!isUpdated) { return; } // required to handle backdrop click.
      if (isUpdated.cancelBtnClicked) { return; }
      // isUpdated.success will be false if there is an error during any of the api calls.
      if (isUpdated.success) {
        this.removeDeletedComm(isUpdated.commId);
        this._snackBar.open('Communication', 'Deleted', {
          duration: 2000
        });
      } else {
        if (isUpdated.error != null) {
          ERROR_MSG = isUpdated.error.message;
        }
        this._snackBar.open(ERROR_MSG, 'Error', {
          duration: 6000
        });
      }
    });
  }
}
